<ng-otp-input
  onkeypress="return (event.charCode == 8 || event.charCode == 0) ? null : event.charCode >= 48 && event.charCode <= 57"
  (onInputChange)="onOtpChange($event)"
  [config]="{ length: length }"
  style="direction: ltr; text-align: left;">
</ng-otp-input>
